import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none",
  viewBox: "0 0 21 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "var(--color-neutral-600)",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "m20 20-4.486-4.494zM18 9.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }